import { component } from 'picoapp'
import { addItemById } from '@/lib/cart.js'
import Modal from '@/utils/modal.js'

class AddToCart {
  constructor(node, ctx) {
    // bindings
    this.onOptionClick = this.onOptionClick.bind(this)
    this.onAddToCartClick = this.onAddToCartClick.bind(this)
    this.onQuantityUpdate = this.onQuantityUpdate.bind(this)
    this.onChangeSelect = this.onChangeSelect.bind(this)
    this.onVariantOptionClick = this.onVariantOptionClick.bind(this)

    // selectors
    this._node = node
    this._product_id = this._node.querySelectorAll('input[name="product_id"]')[0]
    this._quantity = this._node.querySelector('.quantity-item')
    this._recharge_opt = this._node.getElementsByClassName('recharge-opt')
    this._add_to_cart_btn = this._node.getElementsByClassName('add-to-cart-btn')[0]
    this._error = this._node.getElementsByClassName('add-to-cart-error')[0]
    this._price_adjust_btns = Array.from(document.getElementsByClassName('prc-adj-btn'))
    this._recharge_select_opts = this._node.querySelector('.recharge-select-opts')
    this._recharge_select = this._node.querySelector('.recharge-select')
    this._price_compare = document.querySelectorAll('.price-compare')
    this._selecet_wrapper = this._node.querySelector('.select-wrapper')
    this._modal = false

    this._options = Array.from(this._node.getElementsByClassName('add-to-cart-option'))

    // privates
    this._ctx = ctx
    this._recharge_opts = Array.from(this._recharge_opt)
    this._error_to = 0

    // events
    this._add_to_cart_btn.addEventListener('click', this.onAddToCartClick, false)
    this._options.forEach((option) => option.addEventListener('click', this.onVariantOptionClick, false))

    if (this._recharge_opts.length > 1) {
      this._recharge_opts.forEach((option) => {
        option.addEventListener('click', this.onOptionClick, false)
      })
      this._recharge_select.addEventListener('change', this.onChangeSelect, false)
    }

    // unmount
    return this.unmount.bind(this)
  }

  /**
   * Handle option click.
   */
  onOptionClick(e) {
    let el = e.currentTarget,
        price = parseFloat(el.getAttribute('data-price')).toFixed(2).replace('.00', '');

    if (e.target.classList.contains('recharge-info-btn')) {
      this._modal = new Modal()
      this._modal.activateModal()
      return false
    }

    if (el.classList.contains('--selected') === false) {
      this._recharge_opts.forEach((option) => {
        option.classList.remove('--selected');
      });

      el.classList.add('--selected');

      if (el.classList.contains('recharge-select-opts')) {
        this._recharge_select.dispatchEvent(new Event('change'))
        this._selecet_wrapper.style.display = 'block'
      } else {
        this._selecet_wrapper.style.display = 'none'
      }

      this._price_adjust_btns.forEach((btn, i) => {
        let pid = el.hasAttribute('data-spid') ? el.getAttribute('data-spid') : '';
        btn.setAttribute('data-pid', pid);

        let original_price = parseFloat(this._price_compare[0].getAttribute('data-price')).toFixed(2).replace('.00', '');
        if (original_price === price) {
          this._price_compare.forEach((el) => {
            el.innerHTML = `<strong>$${original_price}</strong>`
          })
        } else {
          this._price_compare.forEach((el) => {
            el.innerHTML = `<s>$${original_price}</s> <strong>$${price}</strong>`
          })
        }
      });
    }
  }

  onChangeSelect(e) {
    this._recharge_select_opts.setAttribute('data-spid', this._recharge_select.value)

    this._price_adjust_btns.forEach((btn, i) => {
      btn.setAttribute('data-pid', this._recharge_select.value);
    });
  }

  onVariantOptionClick(e) {
    if (e.currentTarget.classList.contains('disabled')) {
      return false
    }

    let el = e.currentTarget,
        id = el.getAttribute('data-id'),
        vp = el.getAttribute('data-vp')

    this._price_compare.forEach((el) => {
      el.innerHTML = `<strong>${vp}</strong>`
    })

    this._options.forEach((option) => option.classList.remove('selected'))
    el.classList.add('selected')
    this._product_id.value = id
  }

  /**
   * Add to cart.
   */
  onAddToCartClick() {
    let qty_num = 1,
        selling_id = (this._add_to_cart_btn.getAttribute('data-pid') && this._add_to_cart_btn.getAttribute('data-pid') !== '') ? this._add_to_cart_btn.getAttribute('data-pid') : false;

    if (this._quantity !== null) {
      qty_num = parseInt(this._quantity.innerText, 10)
    }

    Promise.all([
      addItemById(this._product_id.value, qty_num, selling_id)
    ]).then(([{item, cart}]) => {
      // console.log(item, cart)
    }).catch((error) => {
      this.showCartError(error)
    })
  }

  /**
   * Show a cart error.
   */
  showCartError(error) {
    if (error === '') this._error.style.display = 'none'
    else this._error.style.display = 'block'

    this._error.innerText = error

    clearTimeout(this._error_to)
    this._error_to = setTimeout(() => this.showCartError(''), 5000)
  }

  /**
   * Handle quantity update.
   */
  onQuantityUpdate() {
    this._error.innerText = ''
  }

  /**
   * Handle unmount.
   */
  unmount() {
    this._add_to_cart_btn.removeEventListener('click', this.onAddToCartClick, false)
    this._options.forEach((option) => option.removeEventListener('click', this.onVariantOptionClick, false))

    if (this._recharge_opts.length > 1) {
      this._recharge_opts.forEach((option) => option.removeEventListener('click', this.onOptionClick, false))
      this._recharge_select.removeEventListener('change', this.onChangeSelect, false)
    }
  }
}

export default component((node, ctx) => new AddToCart(node, ctx))
